import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 5.002v.5l-8.13 14.99a1 1 0 0 1 -1.74 0l-8.13 -14.989v-.5c0 -1.659 4.03 -3.003 9 -3.003s9 1.344 9 3.002","key":"svg-0"}]]

const IconCone2 = createReactComponent('outline', 'cone-2', 'Cone2', __iconNode);

export default IconCone2;